<template lang="html">
  <div>
    <sui-modal v-model="open" :closable="false">
      <sui-modal-header>Kontakt</sui-modal-header>
      <sui-modal-content scrolling image>
        <sui-modal-description>
          <div class="content">
            <fieldset>
              <legend>&nbsp;Kontakt&nbsp;</legend>
              LAN1 Hotspots GmbH<br><br>
              Gaußstraße 158<br>
              D-22765 Hamburg<br>
              Tel.:<a href="tel:+49040317666666"> +49 (0)40 317 66 66 66</a><br>
              Fax.:<a href="tel:+49040317666633"> +49 (0)40 317 66 66 33</a><br>
              Mail: <a href="mail:hotline@lan1.de">hotline@lan1.de</a>
              <br>
              <br>
            </fieldset>
          </div>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click="toggle">Close</sui-button>
      </sui-modal-actions>
    </sui-modal>
  </div>
</template>

<script>
  export default {
    name: 'Contact',
    props: ['open'],
    methods: {
      toggle(event) {
        if (event) {
          event.preventDefault()
        }
        this.$emit('closeModal')
      },
    },
  };</script>
